// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Fab from "@material-ui/core/Fab";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { buttonStyles } from "../../styles/buttonStyles";
import { iconStyles } from "../../styles/iconStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  ...iconStyles(theme),
  halfRightMargin: {
    marginRight: "5px"
  },
  input: {
    opacity: 0,
    width: "0.1px",
    "&:hover": {
      cursor: "pointer !IMPORTANT"
    }
  }
});

type UploadButtonClassesType = {
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  halfRightMargin: DictionaryType,
  input: DictionaryType
};

type UploadButtonPropsType = {
  classes: UploadButtonClassesType,
  uploadFileActions: Function,
  id: string,
  outerClass?: string,
  isFab?: boolean,
  fileType?: string
};

class UploadButton extends Component<UploadButtonPropsType, *> {
  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div className={this.props.outerClass ? this.props.outerClass : ""}>
        <input
          accept={this.props.fileType ? this.props.fileType : "image/*"}
          onChange={this.props.uploadFileActions}
          id={this.props.id + "-raised-button-file"}
          type="file"
          className={classes.input}
        />
        <label htmlFor={this.props.id + "-raised-button-file"}>
          <Fab
            variant={this.props.isFab ? "round" : "extended"}
            component="span"
            color="primary"
            type="button"
            className={classes.lightBtn}
          >
            <CloudUploadIcon
              className={classNames(
                classes.greenIcon,
                !this.props.isFab && classes.halfRightMargin
              )}
            />
            {this.props.isFab ? "" : "Upload"}
          </Fab>
        </label>
      </div>
    );
  }
}

export default withStyles(styles)(UploadButton);
